{
  "version": 1,
  "asset_id": "f2070399-263e-4360-9935-d8548d577306",
  "project_id": "5ebebed5-d757-4c4f-9e26-a06d6761c2a0",
  "url": "/__l5e/assets-v1/f2070399-263e-4360-9935-d8548d577306/fiege.png",
  "r2_key": "a/v1/5ebebed5-d757-4c4f-9e26-a06d6761c2a0/f2070399-263e-4360-9935-d8548d577306/fiege.png",
  "original_filename": "fiege.png",
  "size": 8446,
  "content_type": "image/png",
  "created_at": "2026-06-25T00:53:33Z"
}
